import iposApi from '../../api/iposApi';
import {getItemType} from '../../helpers/common';
import {hideLoading, showLoading} from './loadingActions';

export const setMenuPresentation = data => ({
  type: 'SET_MENU_PRESENTATION',
  data,
});

export const saveMenuGroups = data => ({
  type: 'SAVE_MENU_GROUPS',
  data,
});

export const clearMenuItems = () => ({
  type: 'CLEAR_MENU_ITEMS'
});

export const saveMenuItems = data => ({
  type: 'SAVE_MENU_ITEMS',
  data,
});

export const storeMenuItems = data => ({
  type: 'STORE_MENU_ITEMS',
  data,
});

export const setItemsFilter = term => ({
  type: 'SET_ITEMS_FILTER',
  term,
});

export const storeMenuItemTypes = data => ({
  type: 'STORE_ITEM_TYPES',
  data,
});

export const setSelectedItem = data => ({
  type: 'SET_SELECTED_ITEM',
  data,
});

export const setSelectedItemSupplements = data => ({
  type: 'SET_SELECTED_ITEM_SUPPLEMENTS',
  data,
});

export const setSelectedItemInstructions = data => ({
  type: 'SET_SELECTED_ITEM_INSTRUCTIONS',
  data,
});

export const setSelectedBusinessLunch = data => ({
  type: 'SET_SELECTED_BUSINESS_LUNCH',
  data,
});

export const selectItem = item => async (dispatch) => {
  await dispatch(setSelectedItem(item));

  // if (item.is_business_lunch_flg === 1) {
  //   await dispatch(loadBusinessLunchInfo(item.menu_item_id));
  // }

  // const menuItems = await dispatch(loadMenuItemSupplements(item.menu_item_id));
  // hideLoading();
  // return menuItems;
};

export const loadtMenuItemTypes = () => async (dispatch, getState) => {
  const {branchInfo} = getState();

  const url = '/GetMenuItemTypes';
  const params = {
    branchId: branchInfo.branch_guid_code
  };

  // const translate = getTranslate(getState().localize);
  // dispatch(showLoading(translate('please_wait')));

  const response = await iposApi.get(url, {params});
  dispatch(storeMenuItemTypes(response.data.items));
  // dispatch(hideLoading());
};

export const loadBusinessLunchInfo = businessLunchId => async (dispatch, getState) => {
  const {branchInfo, currentLanguageId} = getState();

  const url = '/GetBusinessLunchInfo';
  const params = {
    branchId: branchInfo.branch_guid_code,
    business_lunch_id: businessLunchId,
    language_id: currentLanguageId
  };

  const response = await iposApi.get(url, {params});
  await dispatch(setSelectedBusinessLunch(response.data));
  return response.data
};

export const loadMenuGroups = () => async (dispatch, getState) => {
  const {branchInfo, currentLanguageId} = getState();

  const url = '/GetGroupsByBranchId';
  const params = {
    branchId: branchInfo.branch_guid_code,
    language_id: currentLanguageId
  };

  try {

    const response = await iposApi.get(url, {params});
    let groups = [];
    if (response.data.menu_items) {
      groups = response.data.menu_items;
    }

    await dispatch(saveMenuGroups(groups));

  } catch (error) {
    dispatch(() => ({type: 'ERROR', data: error}));
  }
};

export const loadAllGroupsMenuItems = groupId => async (dispatch, getState) => {
  const {branchInfo, menuGroups} = getState();
  try {

    dispatch(showLoading());

    await dispatch(clearMenuItems());

    let promises = [];

    for (const group of menuGroups) {
      // await dispatch(loadMenuItems(group.menu_item_id))
      promises.push(dispatch(loadMenuItems(group.menu_item_id)));
    }

    Promise.all(promises).then(() => {
      dispatch(hideLoading());
    });

  } catch (error) {
    dispatch(() => ({type: 'ERROR', data: error}));
  }
};

export const loadMenuItems = groupId => async (dispatch, getState) => {
  const {branchInfo, currentLanguageId} = getState();

  const url = '/GetMenuItemsByParent';
  const params = {
    branchId: branchInfo.branch_guid_code,
    parentId: groupId,
    language_id: currentLanguageId
  };

  try {

    const response = await iposApi.get(url, {params});
    const items = response.data.menu_items;
    items.forEach((item) => {
      item.parentId = groupId;
    });
    await dispatch(storeMenuItems(items));

  } catch (error) {
    dispatch(() => ({type: 'ERROR', data: error}));
  }
};

export const loadMenuItemSupplements = groupId => async (dispatch, getState) => {
  const {branchInfo, currentLanguageId, menuItemTypes} = getState();

  const url = '/GetMenuItemsByParent';
  const params = {
    branchId: branchInfo.branch_guid_code,
    parentId: groupId,
    language_id: currentLanguageId
  };

  try {

    const response = await iposApi.get(url, {params});
    const items = await response.data.menu_items;
    items.forEach((item) => {
      item.parentId = groupId;
      item.menuItemType = getItemType(item, menuItemTypes);
    });
    await dispatch(setSelectedItemSupplements(items.filter(i => i.menuItemType === 'SUPPLEMENT')));
    await dispatch(setSelectedItemInstructions(items.filter(i => i.menuItemType === 'PREPARATION_INSTRUCTION')));
    return [
      items.filter(i => i.menuItemType === 'SUPPLEMENT'),
      items.filter(i => i.menuItemType === 'PREPARATION_INSTRUCTION')
    ];

  } catch (error) {
    dispatch(() => ({type: 'ERROR', data: error}));
  }
};
